import { ROUTES } from "@/constants/routes";

const main = {
  name: "Site Sketches",
  path: ROUTES.MAIN
};

const siteSketches = {
  main
};

export default siteSketches;
